export class EFreshmanQualificationType {
    public static readonly Freshman = 1;
    public static readonly Transfer = 2;
    public static readonly Returnee = 3;
}